<template>
	<div>
		<header-nav :cur="2" />
		<!-- 头部 -->
		<div class="nav">
			<div class="navtab">
				<span class="top">
					首页&nbsp;>&nbsp;
					<span class="two" @click="back()">课程</span>
					&nbsp;>&nbsp;
					<span class="infor">课程详情</span>
				</span>
			</div>
		</div>
		<div class="pic">
			<div class="navtab">
				<div class="top">
					<span class="name">{{course.courseName}}</span>
					<div class="time">
						<span>发布时间：{{course.createTime}}</span>
						<span>阅读量：{{course.courseViewCount}}</span>
						<span>来源：甘肃</span>
					</div>
				</div>
				<div class="center">
					<img :src="$api.url+course.courseImage" alt="" />
					<div class="cenright">
						<div class="border">
							<div class="title">{{course.courseName}}</div>
							<!-- <div class="teacher">主讲老师：{{formatTeacherNames(course.teacherName)}}</div> -->
						</div>
						<div class="time">
							<span>学时：{{course.credit}}</span>
							<span>章节数：{{course.lessionNum}}</span>
							<span>浏览数：{{course.courseViewCount}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 课程详情 -->
		<div class="datail">
			<div class="navtab content">
				<div class="top">
					<span v-for="(item, index) in detail" :key="index" :class="{ active: index === int }"
						@click="chage(index)">{{ item }}</span>
				</div>
				<div v-if="int === 0">
					<div class="courdetail">
						{{course.courseDescribe}}
					</div>
				</div>

				<div v-if="int === 1 ">
					<div class="courlist" v-for="(objs, index) in chapters" :key="index">
						<div v-if="objs.type==='ml'">
							<div class="title">{{objs.chapterName}}</div>
<!--              <div class="video backg" v-for="(sub, sub_index) in objs.subCourseChapterList" :key="sub_index"-->
<!--                   :class="{ backg: index === i }" @click="tovideo(sub.id,sub.sourceUrl,sub.chapterName,sub.courseId,(index + ',' + sub_index))">-->
                <div class="video" v-for="(sub, sub_index) in objs.subCourseChapterList" :key="sub_index" @click="tovideo(sub.id,sub.sourceUrl,sub.chapterName,sub.courseId,(index + ',' + sub_index))">
								<div class="title_box">
<!--									<img v-if="i === index" src="../../assets/img/course/play_action.svg" alt="" />-->
<!--									<img v-else src="../../assets/img/course/play.svg" alt="" />-->
                  <img v-if="sub.readState != null && sub.readState > 0" src="../../assets/img/course/play_action.svg" alt="" />
                  <img v-if="sub.readState == null || sub.readState == 0" src="../../assets/img/course/play_action.svg" alt="" />
									<div class="tiitle">{{ sub.chapterName}}</div>
								</div>
                  <div v-if="sub.readState == null || sub.readState == 0" class="plan"><el-progress :percentage="0"></el-progress></div>
                  <div v-else class="plan">
					  
					  
					  <el-progress :percentage="sub.readState !=null &&(sub.read_time_length / sub.lengthTime * 100)>95?100:(sub.read_time_length / sub.lengthTime * 100).toFixed(2)"></el-progress></div>
								<!-- <div class="plan">学习进度：85%</div> -->
								<!-- <div class="tiitle right">学习</div> -->
								<div class="tiitle title_right right startplay" v-if="sub.readState == null || sub.readState == 0">开始学习</div>
                  <div class="tiitle title_right right startplay1" v-if="(sub.read_time_length / sub.lengthTime) > 0 && (sub.read_time_length / sub.lengthTime) <= 0.95">继续学习</div>
                  <div class="tiitle title_right right continue" v-if="(sub.read_time_length / sub.lengthTime) >  0.95">温故知新</div>
								<!-- <div class="tiitle right">学习</div> -->
							</div>
						</div>

						<div v-if="objs.type !='ml'">
							<div v-if="objs.type =='video'" class="video"
								@click="tovideo(objs.id,objs.sourceUrl,objs.chapterName,objs.courseId,index)">
								<div class="title_box">
									<img v-if="i === index" src="../../assets/img/course/play_action.svg" alt="" />
									<img v-else src="../../assets/img/course/play_action.svg" alt="" />
									<div class="tiitle">{{ objs.chapterName }}</div>
								</div>
                <div v-if="objs.readState == null || objs.readState == 0" class="plan"><el-progress :percentage="0">开始学习</el-progress></div>
                <div v-else class="plan">
					<el-progress :percentage="(objs.read_time_length / objs.lengthTime * 100)>95?100:(objs.read_time_length / objs.lengthTime * 100).toFixed(2)"></el-progress>
				</div>
				<!-- <div class="tiitle title_right right startplay"  v-if="objs.readState == null || objs.readState == 1">开始学习</div> -->
				<div class="tiitle title_right right startplay"  v-if="objs.readState == null || objs.readState == 0 ">开始学习</div>
				<!-- <div class="tiitle title_right right startplay"  v-if="objs.readState == null || objs.readState == 0 || objs.readState == 1">开始学习</div> -->
               <div class="tiitle title_right right startplay1" v-if="(objs.read_time_length / objs.lengthTime) == 0">开始学习</div>
				<div class="tiitle title_right right startplay1" v-if="(objs.read_time_length / objs.lengthTime) > 0 && (objs.read_time_length / objs.lengthTime) <= 0.95">继续学习</div>
                <div class="tiitle title_right right continue" v-if="(objs.read_time_length / objs.lengthTime) > 0.95">温故知新</div>
							</div>

						</div>
					</div>
				</div>
				<div v-if="int === 2">
					<div class="eval">
						<div class="rate">
							请出您的评价：
							<van-rate v-model="value" :size="38" color="#FF6F00" void-icon="star"
								void-color="#D5D5D3" />
							<span>提交意见</span>
						</div>
						<div class="list">
							<div class="box">
								<img src="../../assets/course.jpg" alt="" />
								<div class="namebox">
									<div class="name">文文跑江湖</div>
									<van-rate v-model="value" :size="17" color="#FF6F00" void-icon="star"
										void-color="#D5D5D3" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer-nav />
	</div>
</template>
<script>
	import {queryCourseList,queryCourseById,queryFavoriteCourseList} from '@/api/course.js'
	import {queryUnLoginChapterTree} from '@/api/chapter.js'
	import headerNav from '../../components/HeaderNav.vue';
	import footerNav from '../../components/FooterBar';
	import Vue from 'vue';
	import {
		Rate
	} from 'vant';

	Vue.use(Rate);
	export default {
		components: {
			headerNav,
			footerNav,
		},
		data() {
			return {
				int: 1,
				detail: ['课程详情', '课程大纲'],
				//detail: ['课程详情', '课程大纲', '课程评论（206条）'],
				i: 0,
				value: 3,
				video: [{
					tiitle: '【回放】卸料平台坍塌风险预测学习（2021/10/28 14:30-16:39）',
					play: '可回放',
				}, ],
				course: '',
				chapters: {},
				id: '',
				loading:null
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.queryCourseInfo(this.id);
			
		},
		methods: {
			loadingShow() {
			  this.loading = this.$loading({
			    text: "正在加载中...",  // 显示文本
			    spinner: "el-icon-loading", // 显示的 icon
			    background: "rgba(0, 0, 0, 0.7)", // loading 遮罩层颜色
			    target: document.querySelector("body"), // 挂载的 DOM 元素
			  });
			},
            formatTeacherNames(str) {
				var name = '';
				var strs = JSON.parse(str);

				for (var i = 0; i< strs.length; i++) {
					if (i == 0) {
						name = name + strs[i];
					} else {
						name = name + ',' + strs[i];
					}
				}
				return name;
			},
			queryCourseInfo(id) {
				var params = {
					'id': id,
					year:localStorage.getItem('year')
				};
				queryCourseById(params).then(res => {
					console.log("JSON.stringify(obj)" + JSON.stringify(res));
					this.course = res.data;
					this.queryCourseChapterInfo(this.id);
				})
			},
			queryCourseChapterInfo(id) {
				this.loadingShow();
				var queryParams = {
					courseId: id,
					year:localStorage.getItem('year')
				}
				queryUnLoginChapterTree(queryParams).then(res => {
					var list = res.rows;
					this.chapters = res.data
					this.loading.close();
				})
			},
			back() {
				this.$router.back(-1);
			},
			chage(int) {
				this.int = int;
			},
			avtvideo(i) {
				this.i = i;
			},
			tovideo(id, videoId, name,courseId,index) {
				localStorage.setItem('chapters', JSON.stringify(this.chapters));
				this.$router.push({
					path: '/course/video',
					query: {
						id: id,
						videoId: videoId,
						name: name,
						courseId:courseId,
						index:index
					}
				});
			}
		},
	};
</script>
<style lang="less" scoped>
	// 公共
	.navtab {
		width: 1280px;
		margin: 0 auto;
	}

	.ignore {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}

	// 头部
	.nav {
		background: #0c0c0c;
		width: 100%;
		height: 50px;

		.top {
			display: block;
			font-size: 16px;
			color: #ffffff;
			padding: 19px 0 24px;

			.two {
				cursor: pointer;
				color: #ffffff;
			}

			.infor {
				color: #2961EF;
			}
		}
	}

	// 城市规划原理
	.pic {
		background: #2e2e2e;
		width: 100%;
		padding: 20px 0;

		.top {
			margin-bottom: 20px;

			.name {
				font-size: 26px;
				color: #ffffff;
				margin-right: 30px;
			}

			.time {
				display: inline-block;
				font-size: 16px;
				color: rgba(255, 255, 255, 0.5);
				position: relative;

				span {
					vertical-align: middle;
					padding: 0 30px;
					height: 10px;
					border-right: 1px solid #999999;

					// &::after {
					//     content: '';
					//     height: 18px;
					//     width: 1px;
					//     position: absolute;
					//     right: 10px;
					//     top: 0;
					// }
					&:nth-child(1) {
						padding: 0 30px 0 0;
					}

					&:nth-child(3) {
						border-right: none;
					}
				}
			}
		}

		.center {
			display: flex;

			img {
				width: 763px;
				height: 461px;
				margin-right: 20px;
			}

			.cenright {
				width: 490px;
				height: 420px;
				background: #ffffff;
				padding: 20px;

				.border {
					border-bottom: 1px solid rgba(112, 112, 112, 0.32);
					margin-bottom: 15px;
					padding-bottom: 20px;

					.title {
						font-size: 26px;
						color: #333333;
					}

					.teacher {
						font-size: 16px;
						color: #2961EF;
						margin: 10px 0;
					}
				}

				.time {
					display: inline-block;
					font-size: 16px;
					color: rgba(119, 119, 119, 0.82);
					position: relative;

					span {
						vertical-align: middle;
						padding: 0 20px;
						height: 10px;
						border-right: 1px solid rgba(119, 119, 119, 0.82);

						// &::after {
						//     content: '';
						//     height: 18px;
						//     width: 1px;
						//     position: absolute;
						//     right: 10px;
						//     top: 0;
						// }
						&:nth-child(1) {
							padding: 0 20px 0 0;
						}

						&:nth-child(3) {
							border-right: none;
						}
					}
				}

				.data {
					font-size: 16px;
					color: #ff5e5e;
					margin: 15px 0;
				}

				.show {
					font-size: 16px;
					color: #777777;
				}

				.money {
					margin: 15px 0 25px;
					font-size: 16px;
					color: #777777;

					span {
						font-size: 30px;
						color: #2961EF;
						vertical-align: middle;
					}
				}

				.buy {
					.all {
						display: inline-block;
						width: 156px;
						height: 44px;
						text-align: center;
						line-height: 44px;
						border-radius: 31px 31px 31px 31px;
						font-size: 19px;

						font-weight: 300;
					}

					.by {
						background: #2961EF;
						color: #ffffff;
						margin-right: 40px;
					}

					.add {
						background: #2e2e2e;
						color: #ffffff;
					}
				}
			}
		}
	}

	// 课程详情
	.datail {
		background: #fafafa;
		width: 100%;
		padding: 20px 0;

		.content {
			background: #ffffff;

			.top {
				font-size: 20px;

				font-weight: 300;
				color: rgba(51, 51, 51, 0.6);
				display: flex;
				width: 100%;
				border-bottom: 1px solid rgba(112, 112, 112, 0.15);

				span {
					cursor: pointer;
					padding: 0 30px;
					display: inline-block;
					height: 70px;
					line-height: 70px;
				}

				.active {
					color: #2961EF;
					border-bottom: 1px solid #2961EF;
				}
			}

			.teach {
				font-size: 16px;

				font-weight: 300;
				color: rgba(85, 85, 85, 1);
				line-height: 30px;
			}

			.courdetail {
				padding: 35px 50px;
			}

			.show {
				margin: 40px 0;

				p {
					color: #2961EF;
				}
			}

			.courlist {
				padding: 0 30px;

				.title {
					padding-left: 10px;
					line-height: 20px;
					font-size: 20px;

					font-weight: 300;
					color: #333333;
					border-left: 7px solid #2961EF;
					margin: 30px 0 0 0;
          background: #fafafa;
          padding:15px 0 15px 15px;

				}

				.backg {
					background: rgba(250, 250, 250, 1);
				}

				.video {
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px solid rgba(112, 112, 112, 0.14);
					padding: 15px 22px 15px 0;
					height: auto;


          .title_box{
            width: calc(100% - 44px);
            display: flex;
            align-items: center;
            padding:0 15px 0 0;

          }

          .plan{
            width: 340px;
            margin-left: 0!important;
            padding:0 10px 0 0;
          }

          .title_right{
            width: 90px;
            text-align: center;
          }

					img {
						width: 20px;
						height: 18px;
						margin-right: 15px;
						display: inline-block;
						vertical-align: middle;
					}

					.tiitle {
						display: inline-block;
						vertical-align: middle;
						font-size: 16px;
						font-weight: 300;
						color: #000;
					}

          .continue{
            background: #2961ef;
            color: #fff;
            font-size: 14px;
            border-radius: 100px;
            padding:5px 15px;
            border: 1px solid #2961ef;
          }

          .startplay{
            background: #fafafa;
            color: #2961ef;
            font-size: 14px;
            border-radius: 100px;
            padding:5px 15px;
            border: 1px solid #e1e1e1;
          }
          .startplay1{
            background: #f2f6ff;
            color: #2961ef;
            font-size: 14px;
            border-radius: 100px;
            padding:5px 15px;
            border: 1px solid #2961ef;
          }

					.plan {
						margin-left: 300px;
						font-size: 16px;
						color: #2961EF;
					}

					.right {}
				}
			}

			.eval {
				padding: 26px 36px;

				.rate {
					font-size: 18px;

					font-weight: 300;
					color: #484747;
					border-bottom: 1px solid rgba(112, 112, 112, 0.41);
					padding-bottom: 26px;

					span {
						float: right;
						display: inline-block;
						width: 156px;
						height: 44px;
						text-align: center;
						background: #2961EF;
						border-radius: 31px 31px 31px 31px;
						line-height: 44px;
						font-size: 18px;

						font-weight: 300;
						color: rgba(255, 255, 255, 0.8);
					}
				}

				.list {
					display: flex;
					// justify-content: space-between;
					flex-wrap: wrap;
					align-items: center;

					.box {
						display: flex;
						align-items: center;
						width: 219px;
						height: 76px;
						margin-top: 27px;
						background: #fafafa;
						border-radius: 5px 5px 5px 5px;
						opacity: 1;
						border: 1px solid rgba(239, 239, 239, 0.9803921568627451);
						margin-right: 25px;

						&:nth-child(5n) {
							margin-right: 0;
						}

						img {
							width: 58px;
							height: 58px;
							border-radius: 50%;
							margin: 0 17px 0 11px;
						}

						.namebox {
							.name {
								font-size: 16px;

								font-weight: 300;
								color: #484747;
								margin-bottom: 10px;
							}
						}
					}
				}
			}
		}
	}
</style>